export default "__VITE_ASSET__CbvA2QIi__"